const format = new Intl.DateTimeFormat("en-GB", { dateStyle: "long" });

/** A date written out, the day first: 6 October 2026. */
export const longDate = (date: Date): string => format.format(date);
